const EraserIcon = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.93934 14.7723C1.35355 14.1865 1.35355 13.2368 1.93934 12.651L4.58763 10.0027L12.5193 17.9471L11.0463 19.4201H20.9749C21.4185 19.4201 21.7782 19.7797 21.7782 20.2234C21.7782 20.667 21.4185 21.0266 20.9749 21.0266H8.88945C8.83354 21.0293 8.7775 21.0289 8.72162 21.0254C8.71252 21.0249 8.70347 21.0242 8.69446 21.0234C8.35228 20.9956 8.01782 20.8508 7.75604 20.589L1.93934 14.7723ZM13.6314 16.835L5.6997 8.89064L11.151 3.43934C11.7368 2.85355 12.6865 2.85355 13.2723 3.43934L19.089 9.25604C19.6748 9.84183 19.6748 10.7916 19.089 11.3774L13.6314 16.835Z"
  />
);

export default EraserIcon;
